module.exports = __webpack_public_path__ + "img/panasiuk.0c700fb5.jpg";